import LinkBlock from './LinkBlock';

globalThis.LinkBlockComponents = {
  LinkBlock,
};
